export const INDICATOR_VARIANT = {
  success: 'success',
  error: 'error',
};
